import { typeAttributeKeys, extractibleAttributeKeys } from "@treegram/viewer-core";
import MeasureRepresentationType from "@/models/types/measure-representation-type.ts";
import MeasureType from "./measure-type.ts";

class MeasureRepresentation {
    measureRepresentationId: string;

    measureShapeId: string;

    name: MeasureRepresentationType;

    dataFormatType: Record<string, unknown> | undefined = undefined;

    dataFormatInstance: Record<string, unknown> | undefined = undefined;

    measureTypes: MeasureType[] = [];

    constructor(representationId: string, shapeId: string, name: string) {
        this.measureRepresentationId = representationId;
        this.measureShapeId = shapeId;
        this.name = name as MeasureRepresentationType;
        this.dataFormatType = Object.fromEntries(
            typeAttributeKeys(representationId).map((key) => [
                key,
                ({ color: "hex", symbol: "text" } as Record<string, string>)[key] ?? "number",
            ]),
        );
        this.dataFormatInstance = Object.fromEntries(
            extractibleAttributeKeys(representationId)
                .filter((key) => key !== "number" && !Object.hasOwn(this.dataFormatType!, key))
                .map((key) => [key, "number"]),
        );
    }
}

export default MeasureRepresentation;
